import type { FC } from 'react';
import React from 'react';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import { Stack } from '@mui/material';

import type { BaseSnackbarProps } from '../index';
import BaseSnackbar from '../index';

import { styles } from './index.styles';

type SuccessSnackbarProps = Omit<BaseSnackbarProps, 'leftColumn'>;

const SuccessSnackbar: FC<SuccessSnackbarProps> = ({
  onClose,
  open,
  snackbarProps,
  snackbarContentProps,
  title,
  message,
  testId,
}) => (
  <BaseSnackbar
    open={open}
    onClose={onClose}
    title={title}
    message={message}
    snackbarProps={snackbarProps}
    snackbarContentProps={snackbarContentProps}
    testId={testId}
    leftColumn={
      <Stack sx={styles.successSnackbarCheckmark}>
        <CheckCircleOutline />
      </Stack>
    }
  />
);

export default SuccessSnackbar;
